const rankingItems = [
  { rank: 1, title: '沙丘：第二部', type: '科幻', hot: '🔥 98.7万', trend: 'up' },
  { rank: 2, title: '周处除三害', type: '动作', hot: '🔥 86.3万', trend: 'up' },
  { rank: 3, title: '奥本海默', type: '传记', hot: '🔥 75.2万', trend: 'up' },
  { rank: 4, title: '孤注一掷', type: '犯罪', hot: '72.8万', trend: 'down' },
  { rank: 5, title: '芭比', type: '喜剧', hot: '68.4万', trend: 'down' },
  { rank: 6, title: '首尔之春', type: '剧情', hot: '61.5万', trend: 'new' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-sm font-medium mb-4 whitespace-nowrap">
            实时榜单
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            热门影片排行
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            基于全网搜索热度与播放量综合排序，每周一更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/60 overflow-hidden">
            {rankingItems.map((item, i) => (
              <div
                key={item.rank}
                className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-200/50 transition-colors ${
                  i < rankingItems.length - 1 ? 'border-b border-background-200/60' : ''
                }`}
              >
                <div className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 font-bold text-sm ${
                  item.rank === 1
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-primary-400 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 truncate">
                    {item.title}
                  </h3>
                </div>

                <span className="text-xs font-medium text-foreground-500 bg-background-200/70 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {item.type}
                </span>

                <span className="text-sm font-medium text-foreground-600 whitespace-nowrap hidden sm:block">
                  {item.hot}
                </span>

                <span className="text-sm whitespace-nowrap">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-green-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-red-400"></i>}
                  {item.trend === 'new' && <span className="text-xs font-semibold text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full">NEW</span>}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}